import { SkeletonItem } from '@fluentui/react-components';
import { times } from 'lodash';
import React from 'react';

import './ClassbookCourseStats.scss';

/**
 * Renders without wrapping the inner `.statsCard` in a Fluent `<Skeleton>`
 * parent. The intermediate `.fui-Skeleton` div would otherwise break the
 * `.statsCardWrapper > .statsCard { flex: 1 }` chain and shrink the card.
 * `<SkeletonItem>` uses the same animation/appearance defaults without an
 * explicit `<Skeleton>` ancestor.
 */
const SkeletonStatsCard: React.FC<{}> = () => {
  return (
    <div className="statsCardWrapper">
      <div className="statsCard">
        <div className="label">
          <div className="flex items-end statsCardLabelRow">
            <SkeletonItem className="statsCardValueSkeleton" />
            <SkeletonItem className="statsCardLabelSkeleton" />
          </div>
        </div>
        <SkeletonItem className="statsCardButtonSkeleton" />
      </div>
    </div>
  );
};

/**
 * Loading placeholder for the stats cards shown on the top of
 * the course class book.
 */
export const ClassbookCourseStatsSkeleton: React.FC<{}> = () => {
  return (
    <div className="currentTeachingUnitStats">
      {times(4, index => (
        <SkeletonStatsCard key={index} />
      ))}
    </div>
  );
};
